import { render, staticRenderFns } from "./workload-add.vue?vue&type=template&id=84ed03b2&scoped=true&"
import script from "./workload-add.vue?vue&type=script&lang=js&"
export * from "./workload-add.vue?vue&type=script&lang=js&"
import style0 from "./workload-add.vue?vue&type=style&index=0&id=84ed03b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ed03b2",
  null
  
)

export default component.exports